export default "__VITE_ASSET__E0d2fwRz__"